import { render, staticRenderFns } from "./LandingTitleExtended.vue?vue&type=template&id=ba3e0466&scoped=true"
import script from "./LandingTitleExtended.vue?vue&type=script&lang=js"
export * from "./LandingTitleExtended.vue?vue&type=script&lang=js"
import style0 from "./LandingTitleExtended.vue?vue&type=style&index=0&id=ba3e0466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3e0466",
  null
  
)

export default component.exports